// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","ForumCommentAdd__blockedNotice":"pj_a bhy_sn bhy_sv bhy_sw bhy_kx bhy_ky bhy_ke undefined bhy_vt"};